import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class AccessControlIcon extends BaseIcon {
  getChildren = () => [
    <g fill={ this.getColor() }>
      <rect x="8" y="11" width="2" height="2"/>
      <rect x="8" y="3" width="6" height="7"/>
      <path d="M7,2.3C6.5,1.9,6,1.5,5.4,1.2C4.3,0.6,3.2,0.2,2,0v10c1,0.2,2,0.5,2.8,1.1C5.6,11.7,6.3,12.3,7,13l0,0V2.3z"/>
      <path d="M1,11V3H0v11h6.1c-0.7-0.7-1.4-1.3-2.2-1.9C3,11.5,2,11.2,1,11z"/>
      <rect x="11" y="11" width="2" height="2"/>
      <rect x="14" y="11" width="2" height="2"/>
      <rect x="15" y="14" width="1" height="2"/>
      <rect x="8" y="14" width="3" height="2"/>
      <rect x="12" y="14" width="2" height="2"/>
    </g> ]
  getViewBox = () => '0 0 16 16'
}


